import React from "react";

const UnderProcess = () => {
	return (
		<div className="rpannel-compo">
			<h1>Under Process... Coming Soon</h1>
		</div>
	);
};

export default UnderProcess;
